/**
 * Duration <-> sinceWhen conversions for the chief-complaints editor.
 *
 * The API stores an absolute `sinceWhen` date. The UI collects a
 * years/months/days duration and derives the date locally (or falls back to
 * the raw date if the user edits the auto-calc later).
 *
 * Kept intentionally simple — a month is 30 days, a year 365. Good enough for
 * the "how long has this been going on" UX; the server never re-derives.
 */

export function durationToSinceWhen(years, months, days, from = new Date()) {
  const y = Number(years) || 0;
  const m = Number(months) || 0;
  const d = Number(days) || 0;
  const base = new Date(from.getTime());
  base.setFullYear(base.getFullYear() - y);
  base.setMonth(base.getMonth() - m);
  base.setDate(base.getDate() - d);
  return base;
}

export function sinceWhenToDuration(sinceWhen, to = new Date()) {
  if (!sinceWhen) return { years: 0, months: 0, days: 0 };
  const start = new Date(sinceWhen);
  if (isNaN(start.getTime())) return { years: 0, months: 0, days: 0 };
  let years = to.getFullYear() - start.getFullYear();
  let months = to.getMonth() - start.getMonth();
  let days = to.getDate() - start.getDate();
  if (days < 0) {
    months -= 1;
    days += 30;
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  if (years < 0) years = 0;
  return { years, months: Math.max(0, months), days: Math.max(0, days) };
}

// "08 Jan 2026" — matches the "Since when" column in the Figma table.
export function formatShortDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

// ISO string with UTC — matches what api-cc-v2-service expects for time.Time.
export function toIsoUtc(date) {
  return new Date(date).toISOString();
}
